import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3faa826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-page" }
const _hoisted_2 = { class: "cart-page__content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "cart-page__loader"
}
const _hoisted_5 = {
  key: 1,
  class: "cart-page__empty"
}
const _hoisted_6 = {
  key: 2,
  class: "cart-items-list"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_10 = {
  key: 0,
  class: ""
}

import { useTelegramWebApp } from '@/services/telegram-web-app';
import useShoppingCartStore from '@/store/shopping-cart';
import AppHeader from '@/components/AppHeader.vue';
import CartCard from '@/components/CartCard.vue';
import { onMounted, watch } from 'vue';
import router from '@/router';
import AppLoader from '@/components/AppLoader.vue';
import useShippingMethodsStore from '@/store/shipping-methods';
import usePaymentMethodsStore from '@/store/payment-methods';
import { useI18n } from 'vue-i18n';
import { onUnmounted } from '@vue/runtime-core';
import useProductsStore from '@/store/products';
import helpers from '@/helpers';
import useAppConfigStore from '@/store/app-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartPage',
  setup(__props) {

// eslint-disable-next-line import/no-cycle
const shoppingCartStore = useShoppingCartStore();
const productsStore = useProductsStore();
const telegramWebApp = useTelegramWebApp();
const shippingMethodsStore = useShippingMethodsStore();
const paymentMethodsStore = usePaymentMethodsStore();
const i18n = useI18n();
const appConfigStore = useAppConfigStore();

const onMainBtnClick = () => {
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const productKey in shoppingCartStore.products) {
    const cartProduct = shoppingCartStore.products[productKey];
    const productQuantity = productsStore.getProductQuantity(cartProduct.product.productId);
    if (cartProduct.quantity > productQuantity) {
      let msg = `${i18n.t('errorOrderNotInStock')}\n\n`;
      msg += i18n.t('errorOrderNotInStockProduct', {
        productName: cartProduct.product.name,
        cartQuantity: cartProduct.quantity,
        productQuantity,
      });
      telegramWebApp.showAlert(msg);
      return;
    }
  }
  router.push({ name: 'checkout' });
};

onMounted(() => {
  telegramWebApp.showMainBtn(i18n.t('checkoutOrder'), onMainBtnClick);
  if (!productsStore.isProductsLoaded && !productsStore.isLoadingProducts) {
    productsStore.loadProducts();
  }
  if (shoppingCartStore.totalCost < appConfigStore.config.min_order_amount) {telegramWebApp.hideMainBtn();}
  shippingMethodsStore.loadMethods();
  paymentMethodsStore.loadMethods();
});

onUnmounted(() => {
  telegramWebApp.removeMainBtnHandler(onMainBtnClick);
});

watch(() => shoppingCartStore.totalQuantity, () => {
  if (shoppingCartStore.totalQuantity === 0) telegramWebApp.hideMainBtn();
  if (shoppingCartStore.totalCost < appConfigStore.config.min_order_amount) {telegramWebApp.hideMainBtn();} 
  else telegramWebApp.showMainBtn(i18n.t('checkoutOrder'), onMainBtnClick);
});

console.log(shoppingCartStore);

return (_ctx: any,_cache: any) => {
  const _component_icon_warning = _resolveComponent("icon-warning")!
  const _component_app_alert = _resolveComponent("app-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      title: _ctx.$t('yourOrder'),
      "with-search": false
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(shoppingCartStore).isLoadingCart || _unref(productsStore).isLoadingProducts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AppLoader)
            ]))
          : (_unref(shoppingCartStore).totalQuantity === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('cartIsEmpty')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shoppingCartStore).products, (cartProduct) => {
                  return (_openBlock(), _createBlock(CartCard, {
                    key: cartProduct.product.productId,
                    "cart-product": cartProduct
                  }, null, 8, ["cart-product"]))
                }), 128)),
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('total')) + "  " + _toDisplayString(_unref(helpers).formatCurrency(_unref(shoppingCartStore).totalCost)), 1),
                (_unref(shoppingCartStore).totalCost < _unref(appConfigStore).config.min_order_amount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('errorMinOrderAmount', {
              min_order_amount: _unref(helpers).formatCurrency( _unref(appConfigStore).config.min_order_amount ),
              })), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_app_alert, { class: "checkout-confirm-page__alert" }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_icon_warning)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('priceCanBeChange')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
      ])
    ])
  ]))
}
}

})